import { useNProgress } from '../hooks/useNProgress';
import { getCurrentSubscriptionPlanName } from '../utils/subscription'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import AccountSelection from '../pages/AccountSelectionPage'
import Agency from '../pages/AgencyPage'
import CancelPlanPage from '../pages/CancelPlanPage'
import DefaulterPage from '../pages/DefaulterPage'
import IndividualUser from '../pages/IndividualUser'
import PlansPage from '../pages/PlansPage'
import PrivacyPolicies from '../pages/PrivacyPolicies'
import SignIn from '../pages/SignIn'
import StepsPage from '../pages/StepsPage'
import TermsOfUse from '../pages/TermsOfUse'
import WelcomePage from '../pages/WelcomePage'

import Campaign from '../pages/Campaign'
import FastPublishing from '../pages/FastPublishing'
import FastPublishing1 from '../pages/FastPublishing1'
// import FirstPublication from '../pages/FirstPublication'
import LinkedinRedirection from '../pages/LinkedinRedirection'
import LoginCompletion from '../pages/LoginCompletion'
import NewCampaignForm from '../pages/NewCampaignFormPage'
import NewPostForm from '../pages/NewPostFormPage'
import NewPostPage from '../pages/NewPostPage'
import NewPublicationPage from '../pages/NewPublicationPage'
import NewPublicationPageCampaign from '../pages/NewPublicationPageCampaign'
import NewPublicationPageIA from '../pages/NewPublicationPageIA'
import NewPublicationPageMyPublication from '../pages/NewPublicationPageMyPublication'
import PlanCheckout from '../pages/PlanCheckout'
import PlanCheckoutUser from '../pages/PlanCheckoutUser'
import PricingSuccess from '../pages/PricingSuccess'
import ProductsPage from '../pages/ProductsPage'
import ProductsPageView from '../pages/ProductsPageView'
import SchedulePublicationPage from '../pages/SchedulePublicationPage'
import SchedulingPage from '../pages/SchedulingPage'
import SocialMediaRedirect from '../pages/SocialMediaRedirect'
import TargetAudience from '../pages/TargetAudience'
import UserList from '../pages/UserList'

import { ClientPage } from '../pages/ClientPage'
import { DraftPage } from '../pages/DraftPage'
import { HistoryPage } from '../pages/HistoryPage'
import { MyAccountPage } from '../pages/MyAccountPage'
import { PrototypePage } from '../pages/PrototypePage'
import { ProtectedLayout } from './ProtectedLayout'
import { PublicLayout } from './PublicLayout'

import { DemoPage } from '../pages/DemoPage'
import Settings from '../pages/Settings'
import TimeLinePage from '../pages/TimeLinePage'

import ChatPage from '../pages/ChatPage'

import ForgotPassword from '../pages/ForgotPassword'
import Register from '../pages/Register'
import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { Login, SubscriptionService } from '../services'
import Loading from '../components/Loading'
import { isPublicAuthRoute, hasValidAuthToken } from '../utils/unauthorizedSession'
import Pricing from '../pages/Pricing';
import { ChatSocketPage } from '../pages/ChatSocketPage';
import CampaignChatPage from '../pages/CampaignChat';
import AIManagerPage from '../pages/AIManagerPage';
import PromptManagerListPage from '../pages/PromptManagerListPage';
import PromptManagerEditPage from '../pages/PromptManagerEditPage';
import PromptManagerCreatePage from '../pages/PromptManagerCreatePage';

export default function RoutesAll() {

  const navigation = useNavigate();
  const location = useLocation();
  const { login, logout, userData, userPlan, setUserPlan } = useAuth()
  const [isLoading, setIsLoading] = useState(true)
  const subscriptionPlanLoadedRef = useRef(false)
  const isProductionStage =
    String(import.meta.env.VITE_STAGE || import.meta.env.STAGE || '').toLowerCase() ===
    'production'



  useNProgress();

  useEffect(() => {
    if (!userData) {
      subscriptionPlanLoadedRef.current = false
    }
  }, [userData])

  useEffect(() => {
    let cancelled = false
    const path = location.pathname.toLowerCase()
    const hasAuthCode =
      path.endsWith('/plancheckoutuser') || path.endsWith('/plancheckout')
    const isWelcomeUser = path === '/welcomeuser'

    const finishLoading = () => {
      if (!cancelled) {
        setIsLoading(false)
      }
    }

    // Rotas públicas de login não precisam de bootstrap assíncrono
    if (isPublicAuthRoute(path) && !hasAuthCode && !isWelcomeUser) {
      finishLoading()
      return () => {
        cancelled = true
      }
    }

    const tryLoginWithCode = async () => {
      let planLocal = userPlan

      try {
        if (
          userData &&
          hasValidAuthToken() &&
          !userPlan &&
          !subscriptionPlanLoadedRef.current &&
          !isPublicAuthRoute(path)
        ) {
          subscriptionPlanLoadedRef.current = true

          try {
            const activeSubscription = await SubscriptionService.getActiveSubscription()
            const activeSubscriptions = activeSubscription?.data ? [activeSubscription.data] : []
            const currentPlanName = getCurrentSubscriptionPlanName(activeSubscriptions)

            if (!cancelled) {
              setUserPlan(currentPlanName)
              planLocal = currentPlanName
            }
          } catch {
            subscriptionPlanLoadedRef.current = false
          }
        }

        if (path.endsWith('/plancheckoutuser')) {
          const query = new URLSearchParams(location.search)
          const code = query.get('code')

          if (code) {
            const loginData = await Login.postAuthCode(code)

            if (loginData?.data) {
              const loginDataRet = { ...loginData.data }
              await login(loginDataRet, `/PlanCheckoutUser?origin=mobile&plan=${planLocal || userPlan || ''}`)
            } else {
              await logout()
            }
          }
        }

        if (path.endsWith('/plancheckout')) {
          const query = new URLSearchParams(location.search)
          const code = query.get('code')

          if (code) {
            const loginData = await Login.postAuthCode(code)
            if (loginData?.data) {
              const loginDataRet = { ...loginData.data }
              await login(loginDataRet, `/PlanCheckout?origin=mobile&plan=${planLocal || userPlan || ''}`)
            } else {
              await logout()
            }
          }
        }

        if (isWelcomeUser) {
          const query = new URLSearchParams(location.search)
          const origin = query.get('origin')

          if (origin === 'mobile') {
            navigation(`/ChatSocket?origin=mobile&plan=${planLocal || userPlan || ''}`)
          } else {
            navigation('/ChatSocket')
          }
        }
      } finally {
        finishLoading()
      }
    }

    tryLoginWithCode()

    return () => {
      cancelled = true
    }
  }, [location.pathname, location.search, login, logout, navigation, setUserPlan, userData, userPlan])


  const PublicRoutesLogin = (isLoading) => {
    return (
      <Route element={<PublicLayout isLoading={isLoading} />}>
        <Route path="/" element={null} />
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/PricingSuccess" element={<PricingSuccess />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/AccountSelectionPage" element={<AccountSelection />} />
        <Route path="/IndividualUser" element={<IndividualUser />} />
        <Route path="/Agency" element={<Agency />} />
        <Route path="/PrivacyPolicies" element={<PrivacyPolicies />} />
        <Route path="/TermsOfUse" element={<TermsOfUse />} />
        <Route path="/CancelPlanPage" element={<CancelPlanPage />} />
        <Route path="/FastPublishing" element={<FastPublishing />} />
        <Route path="/DefaulterPage" element={<DefaulterPage />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
      </Route>
    )
  }


  const PrivateRoutes = () => {
    return (
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<ChatSocketPage />} />
        <Route path="/WelcomePage" element={<WelcomePage />} />
        <Route path="/FastPublishing1" element={<FastPublishing1 />} />
        <Route path="/StepsPage" element={<StepsPage />} />
        <Route path="/LoginCompletion" element={<LoginCompletion />} />
        <Route path="/Settings" element={<Settings />} />
        <Route path="/TimeLinePage" element={<TimeLinePage />} />
        <Route path="/PlansPage" element={<PlansPage />} />

        <Route path="/NewPostPage" element={<NewPostPage />} />
        <Route path="/SchedulingPage" element={<SchedulingPage />} />
        <Route
          path="/SchedulePublicationPage"
          element={<SchedulePublicationPage />}
        />
        <Route path="/NewPostFormPage" element={<NewPostForm />} />
        <Route path="/NewCampaingFormPage" element={<NewCampaignForm />} />
        <Route path="/History" element={<HistoryPage />} />
        <Route path="/Draft" element={<DraftPage />} />
        <Route path="/UserList" element={<UserList />} />
        <Route path="/TargetAudience" element={<TargetAudience />} />
        <Route path="/Campaign" element={<Campaign />} />
        <Route path="/ProductsPage" element={<ProductsPage />} />
        <Route path="/ProductsPageView" element={<ProductsPageView />} />
        <Route path="/Prototype" element={<PrototypePage />} />
        <Route path="/Clients" element={<ClientPage />} />
        <Route path="/MyAccountPage" element={<MyAccountPage />} />

        <Route path="/DemoPage" element={<DemoPage />} />

        <Route path="/LinkedinRedirection" element={<LinkedinRedirection />} />
        <Route path="/SocialMediaRedirect" element={<SocialMediaRedirect />} />
        <Route path="/PlanCheckout" element={<PlanCheckout />} />
        <Route path="/PlanCheckoutUser" element={<PlanCheckoutUser />} />

        <Route path="/NewPublicationPage" element={<NewPublicationPage />} />
        <Route
          path="/NewPublicationPageIA"
          element={<NewPublicationPageIA />}
        />
        <Route
          path="/NewPublicationPageCampaign"
          element={<NewPublicationPageCampaign />}
        />
        <Route
          path="/NewPublicationPageMyPublication"
          element={<NewPublicationPageMyPublication />}
        />

        <Route path="/ChatPage" element={<ChatPage />} />

        {/* <Route path="/FirstPublication" element={<FirstPublication />} /> */}
        <Route path="/ChatSocket" element={<ChatSocketPage />} />
        <Route path="/AIManager" element={<AIManagerPage />} />
        <Route path="/PromptManagerList" element={<PromptManagerListPage />} />
        <Route path="/PromptManagerCreate" element={<PromptManagerCreatePage />} />
        <Route path="/PromptManagerEdit/:id" element={<PromptManagerEditPage />} />
      </Route>
    )
  }


  if (isLoading)
    return <Loading enable={isLoading} />
  else
    return (
      <Routes>
        {/* Agent chat keeps its own shell/sidebar */}
        <Route path="/campaign/chat" element={<CampaignChatPage />} />
        <Route path="/agent/chat" element={<CampaignChatPage />} />
        {PublicRoutesLogin(isLoading)}
        {PrivateRoutes(isLoading)}
      </Routes>
    )
}
